import { apiFetch } from './client';

/**
 * FASE 4 (El Edificio) — el menú del inquilino activo.
 * Prefijo: /api/modulos
 *
 * **Esta es la única fuente del menú.** El sidebar y el buscador de comandos
 * comen los dos de aquí. Hasta hoy el sidebar tenía una lista de 19 items
 * cableada a mano en el componente: eso hacía que la Fase 3 no sirviera para
 * nada — el servidor decidía qué módulos tiene cada inquilino y el panel le
 * mostraba los mismos links a todo el mundo.
 *
 * Quién decide qué: **el servidor**. Aquí no se filtra por rol ni por módulo.
 * Filtrar en el navegador sería esconder un botón, y esconder un botón no es
 * seguridad — la API responde 403/404 igual, y esta lista solo dice qué tiene
 * sentido dibujar.
 */

/** Una entrada del menú, ya resuelta por el servidor. */
export interface ItemDeMenu {
  ruta: string;
  etiqueta: string;
  /** Nombre del icono de lucide. El panel resuelve el componente. */
  icono: string;
  moduloId: string;
}

export interface GrupoDeMenu {
  /** `atencion` | `crecimiento` | `operacion` | `configuracion` */
  grupo: string;
  items: ItemDeMenu[];
}

/** Una ruta activa. Incluye las que NO se dibujan en el menú (detalles). */
export interface RutaActiva extends ItemDeMenu {
  enMenu: boolean;
  grupo: string;
}

export interface MenuResponse {
  /** Nombre del negocio activo, para el encabezado. */
  negocio: string | null;
  menu: GrupoDeMenu[];
  /** TODAS las rutas que existen para este inquilino y este rol. */
  rutas: RutaActiva[];
  /** `true` si quien pregunta tiene rol de departamento en este negocio: sus rutas mandan sobre su rol. */
  conRolDeDepartamento?: boolean;
}

export function getMenu(): Promise<MenuResponse> {
  return apiFetch<MenuResponse>('/api/modulos/menu');
}
